import drupalHttp from '../drupalHttpService'
import { FORM } from '@lib/const/api-endpoints.const'
import {
  IWebForm,
  IReservationForm,
  IMusicProgramForm,
  IWomensDayForm,
  IWebPerformanceForm,
} from '@interfaces'

/**
 * Form for drupal Http Service
 */
const submitViaApiRoute = async (postData: object) => {
  const response = await fetch('/api/webform/submit', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(postData),
  })

  if (!response.ok) {
    throw new Error('Form submission failed')
  }

  return response.json()
}

export const FormHttpService = {
  post: async (
    postData:
      | IWebForm
      | IReservationForm
      | IMusicProgramForm
      | IWomensDayForm
      | IWebPerformanceForm
  ) => {
    if (typeof window !== 'undefined') {
      return submitViaApiRoute(postData)
    }

    return drupalHttp.post(FORM, postData)
  },
}
